module.exports = __webpack_public_path__ + "img/1554867804.d213f2d4.jpg";